<app-search-filters></app-search-filters>
<app-search-results (scrollToTop)="onScrollToTop()"></app-search-results>
